var map = {
	"./breakout/preview.png": 1401,
	"./dots/preview.png": 453,
	"./hexa/preview.png": 1663,
	"./knife/preview.png": 4693,
	"./match3/preview.png": 5729,
	"./solitaire/preview.png": 3026,
	"./spider/preview.png": 946,
	"./sudoku/preview.png": 3873,
	"./td/preview.png": 1471,
	"./wordscapes/preview.png": 3177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6677;